'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDecimalDelimiterPosition = exports.countDecimalDigits = undefined;
exports.default = getTransformedStringValues;

var _getDecimalDelimiter = require('./get-decimal-delimiter');

var _getDecimalDelimiter2 = _interopRequireDefault(_getDecimalDelimiter);

var _getDigitGroupDelimiter = require('./get-digit-group-delimiter');

var _getDigitGroupDelimiter2 = _interopRequireDefault(_getDigitGroupDelimiter);

var _convertStringToNumber = require('./convert-string-to-number');

var _convertStringToNumber2 = _interopRequireDefault(_convertStringToNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDecimalDelimiterPosition = function getDecimalDelimiterPosition(value, decimalDelimiter) {
  var string = value && value.toString();
  var position = string && string.indexOf(decimalDelimiter);
  return position !== -1 ? position : false;
}; /**
    * Copyright (c) 2015-present, Zippy Technologies
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

var countDecimalDigits = function countDecimalDigits(string, decimalDelimiter, decimalPosition) {
  var position = decimalPosition || getDecimalDelimiterPosition(string, decimalDelimiter);

  if (isNaN(position)) {
    return 0;
  }

  if (typeof position === 'number' && position < string.length) {
    return string.length - position - 1;
  }

  return 0;
};

function getTransformedStringValues(stringInput) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var internalApi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof stringInput !== 'string') {
    stringInput += '';
  }

  if (!stringInput) {
    return ['', null];
  }

  stringInput = stringInput.replace(/[^0-9\,\.\-\+]/g, '');

  if (stringInput === '-' || stringInput === '-.') {
    return [stringInput, null];
  }

  var locale = props.locale,
      _props$min = props.min,
      min = _props$min === undefined ? Number.MIN_SAFE_INTEGER : _props$min,
      _props$max = props.max,
      max = _props$max === undefined ? Number.MAX_SAFE_INTEGER : _props$max,
      suffix = props.suffix,
      prefix = props.prefix;


  var precision = props.precision || null;

  if (precision > 20) {
    precision = 20;
  }

  var _internalApi$getDecim = internalApi.getDecimalDelimiter,
      getDecimalDelimiter = _internalApi$getDecim === undefined ? _getDecimalDelimiter2.default : _internalApi$getDecim,
      _internalApi$getDigit = internalApi.getDigitGroupDelimiter,
      getDigitGroupDelimiter = _internalApi$getDigit === undefined ? _getDigitGroupDelimiter2.default : _internalApi$getDigit,
      _internalApi$convertS = internalApi.convertStringToNumber,
      convertStringToNumber = _internalApi$convertS === undefined ? _convertStringToNumber2.default : _internalApi$convertS;


  var decimalDelimiter = getDecimalDelimiter(locale);

  if (stringInput === decimalDelimiter) {
    return [stringInput, null];
  }

  var decimalDelimiterPosition = getDecimalDelimiterPosition(stringInput, decimalDelimiter);

  var decimalDigitsInInput = countDecimalDigits(stringInput, decimalDelimiter, decimalDelimiterPosition);

  // if we have more decimal digits than what we allow
  if (precision || precision === 0 && decimalDigitsInInput > precision) {
    stringInput = stringInput.substring(0, stringInput.length - (decimalDigitsInInput - precision));
  }

  var digitGroupDelimiter = getDigitGroupDelimiter(locale);

  var parsedResult = convertStringToNumber(stringInput, {
    digitGroupDelimiter: digitGroupDelimiter,
    decimalDelimiter: decimalDelimiter,
    min: min,
    max: max
  });

  if (isNaN(parsedResult)) {
    return ['', null];
  }

  var numberWasClamped = parsedResult === min || parsedResult === max;

  if (numberWasClamped) {
    decimalDigitsInInput = 0;
  }

  var formatingOptions = {
    maximumFractionDigits: precision ? Math.min(precision, 20) : 20,
    minimumFractionDigits: Math.min(precision || decimalDigitsInInput, 20)
  };

  var stringRepresentation = parsedResult.toLocaleString(locale, formatingOptions);

  if (!precision && !numberWasClamped && !decimalDigitsInInput && decimalDelimiterPosition === stringInput.length - 1) {
    stringRepresentation += '.';
  }

  if (prefix) {
    stringRepresentation = prefix + ' ' + stringRepresentation;
  }

  if (suffix) {
    stringRepresentation = stringRepresentation + ' ' + suffix;
  }

  return [stringRepresentation, parsedResult];
}

exports.countDecimalDigits = countDecimalDigits;
exports.getDecimalDelimiterPosition = getDecimalDelimiterPosition;